<div style="overflow: hidden; max-height: 10em; min-height: 8em;">
  <img width="100%" src="assets/Autumn_homepage.jpg" alt="" class="lazy-load loaded" typeof="foaf:Image"
    data-was-processed="true">
</div>

<div class="content-div">
  <div class="error-title" i18n="pages.error.ServerError.title">
    Server Error <span *ngIf="status || error"><span *ngIf="status">{{status}}</span><span
        *ngIf="status && error">:&nbsp;</span><span *ngIf="error">{{error}}</span></span>
  </div>
  <div class="error-message" i18n="pages.error.ServerError.message">
    <h2>Error Details:</h2>
    <p *ngIf="timestamp"><b>Timestamp:</b> {{timestamp}}</p>
    <p *ngIf="status"><b>Status:</b> {{status}}</p>
    <p *ngIf="error"><b>Error:</b> {{error}}</p>
    <p *ngIf="message"><b>Message:</b> {{message}}</p>
    <p *ngIf="path"><b>Path:</b> {{path}}</p>
  </div>
</div>
